import { createApi } from 'api/common/createApi'
import config, { API_TYPES } from 'constants/app-config'

export const nmaApi = createApi({
  baseURL: config[API_TYPES.MT_API_URL],
})
export const awardsApi = createApi({
  baseURL: config[API_TYPES.AWARDS_API_URI],
})
